module.exports = __webpack_public_path__ + "img/data_creditor.2f392b7c.png";